import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { consultarNovidades, registrarLeitura } from '../services/novidades';

const Contexto = createContext(null);

export function NovidadesProvider({ children }) {
    const [dados, setDados] = useState(null);
    const [erro, setErro] = useState(false);
    const [carregando, setCarregando] = useState(true);
    const [salvando, setSalvando] = useState(false);
    const carregar = useCallback(() => {
        setCarregando(true);
        setErro(false);
        return Promise.resolve().then(consultarNovidades)
            .then(setDados).catch(() => setErro(true)).finally(() => setCarregando(false));
    }, []);
    useEffect(() => { carregar(); }, [carregar]);

    const marcarLida = useCallback(async () => {
        if (!dados?.naoLida) return;
        setSalvando(true);
        try {
            await registrarLeitura(dados.versaoId);
            setDados(atual => atual?.versaoId === dados.versaoId ? { ...atual, naoLida: false } : atual);
        } catch (e) {
            if (e.response?.status === 409) await carregar();
            throw e;
        } finally { setSalvando(false); }
    }, [dados, carregar]);

    return <Contexto.Provider value={{ dados, erro, carregando, salvando, carregar, marcarLida }}>{children}</Contexto.Provider>;
}

export const useNovidades = () => useContext(Contexto);
